// removed by extract-text-webpack-plugin
module.exports = {"message":"src-node_modules-kts-scaffold-framework-component-Message-index__message--jUJU7","close":"src-node_modules-kts-scaffold-framework-component-Message-index__close--wNjwJ","show":"src-node_modules-kts-scaffold-framework-component-Message-index__show--3XnGW"};


//////////////////
// WEBPACK FOOTER
// ./src/node_modules/kts-scaffold-framework/component/Message/index.scss
// module id = 2436
// module chunks = 0